import { Theme, css } from '@emotion/react';
import { TypographyColor, TypographyVariant } from './Typography';

// V5-specific helper to get CSS for a TypographyV5 variant
export const typographyVariant =
  (variant: TypographyVariant) =>
  ({ font, typography }: Theme) => {
    switch (variant) {
      case 'display1Bold':
        return css`
          font-family: ${font.condensedBold};
          font-size: ${typography.pxToRem(30)};
          line-height: 1.2;
        `;
      case 'display1Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(30)};
          line-height: 1.2;
        `;
      case 'display2Bold':
        return css`
          font-family: ${font.condensedBold};
          font-size: ${typography.pxToRem(24)};
          line-height: 1.16;
        `;
      case 'display2Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(24)};
          line-height: 1.16;
        `;
      case 'heading1Bold':
        return css`
          font-family: ${font.condensedBold};
          font-size: ${typography.pxToRem(21)};
          line-height: 1.33;
        `;
      case 'heading1Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(21)};
          line-height: 1.33;
        `;
      case 'heading2Bold':
        return css`
          font-family: ${font.condensedBold};
          font-size: ${typography.pxToRem(18)};
          line-height: 1.33;
        `;
      case 'heading2Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(18)};
          line-height: 1.33;
        `;
      case 'body1Bold':
        return css`
          font-family: ${font.bold};
          font-size: ${typography.pxToRem(16)};
          line-height: 1.25;
        `;
      case 'body1Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(16)};
          line-height: 1.25;
        `;
      case 'body1Regular':
        return css`
          font-family: ${font.regular};
          font-size: ${typography.pxToRem(16)};
          line-height: 1.25;
        `;
      case 'body2Bold':
        return css`
          font-family: ${font.bold};
          font-size: ${typography.pxToRem(14)};
          line-height: 1.42;
        `;
      case 'body2Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(14)};
          line-height: 1.42;
        `;
      case 'body2Regular':
        return css`
          font-family: ${font.regular};
          font-size: ${typography.pxToRem(14)};
          line-height: 1.42;
        `;
      case 'caption1Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(12)};
          line-height: 1.33;
        `;
      case 'caption1Regular':
        return css`
          font-family: ${font.regular};
          font-size: ${typography.pxToRem(12)};
          line-height: 1.33;
        `;
      case 'caption2Medium':
        return css`
          font-family: ${font.medium};
          font-size: ${typography.pxToRem(9)};
          line-height: 1.33;
        `;
      case 'caption2Regular':
        return css`
          font-family: ${font.regular};
          font-size: ${typography.pxToRem(9)};
          line-height: 1.33;
        `;
      case 'inheritFont':
        return css``;
      case 'srOnly':
        return css`
          position: absolute;
          height: 1px;
          width: 1px;
          overflow: hidden;
        `;
    }
  };

export const typographyColor = (color: TypographyColor) => (theme: Theme) => {
  switch (color) {
    case 'white':
      return css`
        color: ${theme.colors.textWhite};
      `;
    case 'lighter':
      return css`
        color: ${theme.colors.textLighter};
      `;
    case 'light':
      return css`
        color: ${theme.colors.textLight};
      `;
    case 'base':
      return css`
        color: ${theme.colors.textBase};
      `;
    case 'dark':
      return css`
        color: ${theme.colors.textDark};
      `;
    case 'danger':
      return css`
        color: ${theme.colors.textDanger};
      `;
    case 'primary':
      return css`
        color: ${theme.colors.textPrimary};
      `;
    case 'success':
      return css`
        color: ${theme.colors.textSuccess};
      `;
    case 'warning':
      return css`
        color: ${theme.colors.textWarning};
      `;
    case 'inherit':
      return css`
        color: inherit;
      `;
    default:
      return css``;
  }
};

export const uppercaseTypography = css`
  text-transform: uppercase;
`;
